import React from "react";
import "./Header.scss";
import { cancelIcon } from "view/assets/images";

export default function Header() {
  return (
    <header className={"root-header"}>
      {/*<button*/}
      {/*  className="back-button"*/}
      {/*  onClick={() => {*/}
      {/*    window.history.back();*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <img className="back-icon" src={cancelIcon} alt="cancel" />*/}
      {/*</button>*/}
      {/*<div className="root-header-title">Easyswap</div>*/}
        <a>Swap</a>
        <a>History</a>
    </header>
  );
}
